import { Fit, Alignment } from './constants';

function getUserFileDomainUrl() {
  return (
    (typeof window !== 'undefined' &&
      (window as any).serviceTopology &&
      (window as any).serviceTopology.userFileDomainUrl) ||
    'filesusr.com'
  );
}

function getStaticMediaUrl() {
  return (
    (typeof window !== 'undefined' &&
      (window as any).serviceTopology &&
      (window as any).serviceTopology.mediaRootUrl) ||
    'https://static.wixstatic.com/'
  );
}

export const getThumbnailUrl = (thumbnailUrl: string) => {
  const mediaUrl = getStaticMediaUrl();
  return thumbnailUrl ? `${mediaUrl}/${thumbnailUrl}` : undefined;
};

export const getFileAnimationUrl = (metaSiteId: string, fileUrl: string) => {
  if (fileUrl.startsWith('ugd/')) {
    const userFileDomainUrl = getUserFileDomainUrl();
    return `https://${metaSiteId}.${userFileDomainUrl}/${fileUrl}`;
  } else {
    return fileUrl;
  }
};

export const IsResultFromMediaValid = (result: any) => {
  return (
    result &&
    result.length !== 0 &&
    (result[0].fileUrl as string).endsWith('.riv')
  );
};

export const getDataForNewFile = (result: any) => {
  const thumbnailFileUrl = result.fileOutput.preview[0].url;
  return {
    animationFileUrl: result.fileUrl,
    artboard: '',
    stateMachine: '',
    alt: '',
    thumbnailFileUrl,
    fileName: result.fullTitle,
    fit: Fit.cover.value,
    isAutoPlayOn: true,
    alignment: Alignment.center.value,
    isTouchScrollEnabled: true,
    isDecorative: false,
  };
};
